import React, { useCallback } from 'react';
import { Checkbox } from 'ui';
import { AdministrationMessagesTranslation } from '../../constants';
import { AdministrationMessageItem } from '../types-store';

import styles from './message-form-active.scss';

interface MessageFormActiveProps {
  message: AdministrationMessageItem;
  readOnly: boolean;

  onChange: (active: boolean) => void;

  translation: AdministrationMessagesTranslation;
}

export const MessageFormActive: React.FC<MessageFormActiveProps> = ({
  message, readOnly, onChange, translation
}) => {

  const onChangeHandler = useCallback(
    (value: number) => {
      onChange(!!value);
    },
    []
  );

  return <div className="row">
    <div className="col-lg-6 col-sm-12">
      <Checkbox
        componentId="message-form-active"
        className={styles.checkbox}
        label={{ visible: true, text: translation.active }}
        value={!!message && message.active ? 1 : 0}
        readOnly={readOnly}
        onChange={onChangeHandler}
      />
    </div>
  </div>;
};
